export default __webpack_public_path__ + "static/media/coin.57f2424b.png";